import React, { useEffect } from 'react';
import Text from '@common/text';
import { useChatToast } from '@components/chat/common/chatToast';
import { FontStyle } from '@domain/constant/fontStyle';
import useLocalStorageExpires from '@utils/hooks/useLocalStorageExpires';

export const NOTICE_EXPIRES_KEY = 'chatNoticeExpires';

const NoticeToast = () => {
  const { setExpires, getIsExpired } = useLocalStorageExpires();
  const ChatToast = useChatToast();

  useEffect(() => {
    const isExpires = getIsExpired(NOTICE_EXPIRES_KEY);

    if (isExpires) return;

    ChatToast({
      bottom: 72,
      content: (
        <div>
          <Text element={'span'} fontStyle={FontStyle.B4_M}>
            폭언, 음란, 불법 행위, 상업적 홍보 등 채팅방 사용을 저해하는 활동에 대해 메시지 삭제 및 계정 정지 조치를 할
            수 있습니다.
          </Text>
        </div>
      ),
    });

    setExpires({ key: NOTICE_EXPIRES_KEY });
    return () => {
      setExpires({ key: NOTICE_EXPIRES_KEY });
    };
  }, []);

  return null;
};

export default NoticeToast;
